import { render, staticRenderFns } from "./DashboardStatistics.vue?vue&type=template&id=066f8e2a&scoped=true"
import script from "./DashboardStatistics.vue?vue&type=script&lang=ts"
export * from "./DashboardStatistics.vue?vue&type=script&lang=ts"
import style0 from "./DashboardStatistics.vue?vue&type=style&index=0&id=066f8e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f8e2a",
  null
  
)

export default component.exports